// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const dispositionInReasonOneMax = 1000;

export const DispositionIn = zod.object({
  "disposition": zod.enum(['active', 'parked', 'archived']),
  "reason": zod.union([zod.string().max(dispositionInReasonOneMax),zod.null()]).optional()
});

export type DispositionIn = zod.input<typeof DispositionIn>;
export type DispositionInOutput = zod.output<typeof DispositionIn>;
